import { CodeField } from "@commonlibs";
import styled, { css } from "styled-components";

export const CodeFieldRoot = styled(CodeField)(
    () => css`
        .CodeInputs {
            justify-content: center;
        }
        .FormControl {
            flex: 0;
        }
        .FormControl .TextInput {
            height: 5rem;
            width: 4rem;
        }
    `,
);
